export const getLayerStyle = (theme, style) => {
  if (!style) {
    return theme.feature.default;
  }
  if (typeof style === 'object' || typeof style === 'function') {
    return style;
  } else if (typeof style === 'string') {
    return theme.feature[style];
  }
  throw new Error('Failed to find a valid style for ' + style);
};
